import React, { useCallback } from 'react';
import { useIsInitialized } from '../hooks/use-is-initialized.js';
import { showFirstLayer } from '../utils.js';
/**
 * A button component for opening the Usercentrics dialog where users can
 * adjust their consent settings, and read info about services.
 *
 * The button will be disabled until Usercentrics has been initialized,
 * so for example ad-blockers might prevent it from ever activating.
 */
export const UsercentricsDialogToggle = ({ onClick, children, ...rest }) => {
    const isUsercentricsInitialized = useIsInitialized();
    const handleClick = useCallback((event) => {
        onClick?.(event);
        if (event.defaultPrevented)
            return;
        event.preventDefault();
        if (isUsercentricsInitialized) {
            showFirstLayer();
        }
    }, [isUsercentricsInitialized, onClick]);
    return (React.createElement("button", { ...rest, "aria-haspopup": true, disabled: !isUsercentricsInitialized, onClick: handleClick }, children));
};
UsercentricsDialogToggle.displayName = 'UsercentricsDialogToggle';
